
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin, VuetifyMixin, StringsMixin, AthletesCacheMixin } from '@/mixins';
import { BAEventModel, AthleteProfileModel } from '@/models';
import { athleteApi } from '@/api/AthleteApi';
import { QueryOptions, RepositoryQuery } from '@/../types';
import { DataTableHeader } from 'vuetify';
import { ObjectCache } from '@/helpers/object-cache';
import { baEventApi } from '@/api/BAEventsApi';

@Component
export default class BAEventsAttendeesManagement extends Mixins(VuetifyMixin, BAIconsMixin, StringsMixin, AthletesCacheMixin) {
    @Prop({ required: true }) event: BAEventModel;
    @Prop({ type: Boolean }) icon;
    @Prop({ type: Boolean }) small;
    @Prop({ type: Boolean }) large;

    athletes: Array<AthleteProfileModel>;
    headers: Array<DataTableHeader> = [];
    eventsCache: ObjectCache<BAEventModel> = new ObjectCache<BAEventModel>();

    showDialog: boolean = false;
    onEventsAttendeesBegin() {
        this.showDialog = true;
    }

    onClose() {
        this.showDialog = false
    }

    isLoading: boolean = false;
    errorMessage: string = '';
    async onAthletesClear() {
        this.isLoading = true;
        this.errorMessage = '';
        this.athletes = [];
        this.isLoading = false;
    }
    async onAthletesHasNextEvent() {
        this.isLoading = true;
        this.errorMessage = '';

        this.headers = [
            {text:'Athlete', value:'FullName'},
            {text:'nextUrl', value:'nextUrl'},
            {text:'', value:'actions'},
        ]
        const loading: AthleteProfileModel = new AthleteProfileModel({firstName: 'loading', lastName: 'participants'});
        this.athletes = [loading];

        try {
            const query: RepositoryQuery<AthleteProfileModel> = {
                search: 'baevent',
                fields: ['nextUrl'],
            }
            const options: QueryOptions = {};
            const response = await athleteApi.queryAll(query, options);
            if( this.IsNotEmpty(response) ) {
                this.athletes = response.docs.map(d => new AthleteProfileModel(d))
            }
            for( const a of this.athletes ) {
                const eventId = a.nextUrl.slice(9,a.nextUrl.length);
                const event = this.eventsCache.get(eventId);
                if( this.IsEmpty(event) ) {
                    const dbEvent = await baEventApi.findById(eventId);
                    if( this.IsNotEmpty(dbEvent) ) this.eventsCache.set(dbEvent);
                }
            }
        } catch(e) {
            this.errorMessage = `Error loading Athletes:\n\n ${e}`;
        }
        this.isLoading = false;
    }

    async onAthleteRemoveNextUrl(athlete: AthleteProfileModel) {
        await athleteApi.patch({id: athlete.id, nextUrl: ''});
        athlete.nextUrl = '';
    }
    async onAthleteRemoveAllNextUrl() {
        for( const a of this.athletes ) {
            await this.onAthleteRemoveNextUrl(a);
        }
    }

    EventName(nextUrl: string): string {
        const eventId = nextUrl.slice(9, nextUrl.length);
        const event = this.eventsCache.get(eventId);
        return event?.name;
    }
}
